import * as React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {Breadcrumb} from '~/components/Breadcrumps';
import {pmpLinks} from '~/modules/Pmp/links';
import {SupplyPackagesView} from '~/modules/Pmp/views/SupplyPackagesView';
import {SupplyPackageView} from '~/modules/Pmp/views/SupplyPackageView';
import { DealsView } from './views/DealsView';
import {SensitiveCategoriesReportView} from '~/modules/Pmp/views/SensitiveCategoriesReportView';

export * from './links';

export const PmpRouter = () => <Breadcrumb breadcrumb={{
    to: pmpLinks.deals(),
    title: 'PMP'
}}
>
    <Routes>
        <Route path="deals" element={<DealsView/>}/>
        <Route path="supply-packages" element={<SupplyPackagesView/>}/>
        <Route path="supply-packages/:supplyPackageId" element={<SupplyPackageView/>}/>
        <Route path="sensitive-categories" element={<SensitiveCategoriesReportView/>}/>
        <Route path="*" element={<Navigate to={pmpLinks.deals()} replace />}/>
    </Routes>
</Breadcrumb>;
